class Magnifier {
    constructor(container, productImageClassName, options = {}) {
        this.container = container.get(0);                        // 主图容器
        this.productImageSelector = '.' + productImageClassName;  // 主图 img 选择器
        this.zoomFactor = options.zoomFactor || 2;                // 放大倍数（透镜=图片1/4，2倍正好铺满面板）
        this.scale = options.scale || 1;                          // 主题 pictureScale 配置
        this.lens = null;                                         // 图片上的放大透镜
        this.panel = null;                                        // 右侧放大面板
        this.naturalMap = {};                                     // 每张图片的原始尺寸缓存（图片会随变体/缩略图切换）
        this.visible = false;
        this.lastEvent = null;

        // 确保容器是 relative，透镜和面板才能绝对定位
        if (getComputedStyle(this.container).position === 'static') {
            this.container.style.position = 'relative';
        }

        this.init();
    }

    init() {
        $(this.container).on('mouseenter', () => this.show());
        $(this.container).on('mousemove', (event) => this.move(event));
        $(this.container).on('mouseleave', () => this.hide());
        // 点击图片时收起面板，避免遮挡页面其他内容
        $(this.container).on('click', () => this.hide());
        // 窗口尺寸变化时重新计算位置
        $(window).on('resize.ppmMagnifier', () => {
            if (this.visible && this.lastEvent) this.move(this.lastEvent);
        });
    }

    getImageUrl() {
        this.productImage = $(this.container).find(this.productImageSelector)[0];
        if (this.productImage && this.productImage.src) {
            return this.productImage.src;
        }
        return null;
    }

    // 获取图片原始尺寸（按 url 缓存，支持图片切换）
    getNaturalSize(url) {
        if (this.naturalMap[url]) {
            return Promise.resolve(this.naturalMap[url]);
        }
        return new Promise((resolve) => {
            const img = new Image();
            img.onload = () => {
                const size = { w: img.naturalWidth, h: img.naturalHeight };
                this.naturalMap[url] = size;
                resolve(size);
            };
            img.onerror = () => resolve(null);
            img.src = url;
        });
    }

    // 图片在容器内实际绘制的区域（object-fit: contain 居中 + pictureScale 缩放）
    getDrawRect() {
        const rect = this.container.getBoundingClientRect();
        const cw = rect.width;
        const ch = rect.height;
        const url = this.getImageUrl();
        const natural = url ? this.naturalMap[url] : null;
        if (!natural || !natural.w) {
            return { x: 0, y: 0, w: cw, h: ch };
        }
        const containScale = Math.min(cw / natural.w, ch / natural.h);
        const w = natural.w * containScale * this.scale;
        const h = natural.h * containScale * this.scale;
        return { x: (cw - w) / 2, y: (ch - h) / 2, w, h };
    }

    async show() {
        if (this.visible) return;

        const imageUrl = this.getImageUrl();
        if (!imageUrl) return;

        // 确保图片原始尺寸已加载
        await this.getNaturalSize(imageUrl);

        // 创建透镜（图片上的半透明正方形，大小为图片的1/4）
        if (!this.lens) {
            this.lens = document.createElement('div');
            this.lens.className = 'magnifier-lens';
            this.container.appendChild(this.lens);
        }

        // 创建右侧放大面板（亚马逊风格：放大内容展示在原图右侧）
        if (!this.panel) {
            this.panel = document.createElement('div');
            this.panel.className = 'magnifier-zoom-panel';
            this.panel.style.backgroundRepeat = 'no-repeat';
            this.container.appendChild(this.panel);
        }
        // 图片可能已切换，重新设置面板背景
        this.panel.style.backgroundImage = `url('${imageUrl}')`;

        this.visible = true;
        this.lens.classList.add('active');
        this.panel.classList.add('active');

        if (this.lastEvent) this.move(this.lastEvent);
    }

    move(event) {
        this.lastEvent = event;
        if (!this.visible || !event || !this.lens || !this.panel) return;

        const rect = this.container.getBoundingClientRect();
        const draw = this.getDrawRect();

        // 鼠标相对图片绘制区域的位置
        let x = event.clientX - rect.left;
        let y = event.clientY - rect.top;
        x = Math.max(draw.x, Math.min(x, draw.x + draw.w));
        y = Math.max(draw.y, Math.min(y, draw.y + draw.h));

        // 透镜 = 图片的1/4（整张图分为2x2共4个正方形区域）
        const lensW = draw.w / 2;
        const lensH = draw.h / 2;

        // 透镜中心对准鼠标，并限制完全落在图片范围内
        const lensLeft = Math.max(draw.x, Math.min(x - lensW / 2, draw.x + draw.w - lensW));
        const lensTop = Math.max(draw.y, Math.min(y - lensH / 2, draw.y + draw.h - lensH));

        this.lens.style.width = lensW + 'px';
        this.lens.style.height = lensH + 'px';
        this.lens.style.left = lensLeft + 'px';
        this.lens.style.top = lensTop + 'px';

        // 实际放大倍数 = 面板尺寸 / 透镜尺寸（面板大小变化时映射依然精确、画面完整铺满）
        const zoomScale = lensW > 0 ? this.panel.offsetWidth / lensW : this.zoomFactor;
        this.panel.style.backgroundSize = `${draw.w * zoomScale}px ${draw.h * zoomScale}px`;
        this.panel.style.backgroundPosition = `${-(lensLeft - draw.x) * zoomScale}px ${-(lensTop - draw.y) * zoomScale}px`;
    }

    hide() {
        this.visible = false;
        if (this.lens) this.lens.classList.remove('active');
        if (this.panel) this.panel.classList.remove('active');
    }
}
